import { render, staticRenderFns } from "./car_base2_tab.vue?vue&type=template&id=cabcb0c6&scoped=true"
import script from "./car_base2_tab.vue?vue&type=script&lang=js"
export * from "./car_base2_tab.vue?vue&type=script&lang=js"
import style0 from "./car_base2_tab.vue?vue&type=style&index=0&id=cabcb0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabcb0c6",
  null
  
)

export default component.exports